// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddCust_importCsvCard__lJ62J","addCustomerBtnContainer":"AddCust_addCustomerBtnContainer__cSKBY"};